import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './CustomTile.css';

function CustomTile({
                       imageUrl,
                       textLines = [],
                       backgroundColor = '#e8e4df',
                       showNumber = true,
                       number = '1',
                       numberColor = '#ff8c42',
                       useAuth = false,
                       numberFirst = false,
                       tiny = false,
                       tileClassName = 'custom-tile',
                   }) {
    const [imageSrc, setImageSrc] = useState(null);
    const [imageError, setImageError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    // Pobierz token z Redux
    const accessToken = useSelector((state) => state.tokens.accessToken);

    useEffect(() => {
        let isMounted = true;
        let objectUrl = null;

        const loadImage = async () => {
            if (isMounted) {
                setIsLoading(true);
                setImageError(false);
            }

            if (!imageUrl) {
                setImageError(true);
                setIsLoading(false);
                return;
            }

            // Jeśli useAuth jest true i jest token, pobierz obrazek przez fetch
            if (useAuth && accessToken) {
                try {
                    const response = await fetch(imageUrl, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${accessToken}`,
                        },
                        credentials: 'include',
                        mode: 'cors'
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const blob = await response.blob();

                    if (isMounted) {
                        objectUrl = URL.createObjectURL(blob);
                        setImageSrc(objectUrl);
                        setImageError(false);
                        setIsLoading(false);
                    }
                } catch (error) {
                    console.error('Błąd ładowania obrazka:', error);
                    if (isMounted) {
                        setImageError(true);
                        setIsLoading(false);
                    }
                }
            } else {
                // Bez autoryzacji
                if (isMounted) {
                    setImageSrc(imageUrl);
                    setImageError(false);
                    setIsLoading(false);
                }
            }
        };

        loadImage();

        // Cleanup
        return () => {
            isMounted = false;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [imageUrl, accessToken, useAuth]);

    return (
        <div className={tileClassName} style={{ backgroundColor }}>
            <div className={textLines.length < 2 ? "custom-tile-content custom-min-height-80" : "custom-tile-content"}>
                {showNumber && numberFirst && (
                    <div
                        className={textLines.length  < 2 ? "custom-number custom-font-80" : "custom-number"}
                        style={{ color: numberColor }}
                    >
                        {number}
                    </div>
                )}

                <div className={textLines.length  < 2 ? "custom-image-container custom-height-80" : "custom-image-container"}>
                    {isLoading ? (
                        <div className="custom-image-placeholder">
                            <span>Ładowanie...</span>
                        </div>
                    ) : imageError ? (
                        <div className="custom-image-placeholder">
                            <span>Brak obrazka</span>
                        </div>
                    ) : (
                        <img
                            src={imageSrc}
                            alt={textLines[0] || 'Event'}
                            className="custom-image"
                            onError={() => {
                                console.error('Błąd ładowania obrazka (img tag)');
                                setImageError(true);
                            }}
                        />
                    )}
                </div>

                {showNumber && !numberFirst && (
                    <div
                        className={textLines.length  < 2 ? "custom-number custom-font-80" : "custom-number"}
                        style={{ color: numberColor }}
                    >
                        {number}
                    </div>
                )}

                <div className="custom-info">

                    {!tiny && textLines.map((line, index) => (
                        <div
                            key={index}
                            className={`custom-text custom-text-${index + 1}`}
                        >
                            {line}
                        </div>
                    ))}
                    {tiny &&
                        <div
                            key={1}
                            className={`custom-text custom-text-1`}
                        >
                            {textLines.values().next().value}
                        </div>}
                </div>
            </div>
        </div>
    );
}

export default CustomTile;
